<template>
  <div class="pagination-container flex flex-wrap items-center">
    <ul class="pagination row">
      <li
        class="col-xs-2 col-sm-1"
        v-for="(page, index) in pages"
        :key="index"
        :class="{ 'active': page == pagination.current_page }">
        <a class="pagination-link" @click="handleSelectPageCallback(page)">{{ page }}</a>
      </li>

      <li class="col-xs-2 col-sm-2" v-if="pagination.prev_page_url">
        <a class="pagination-link" aria-label="Previous" @click="handleSelectPageCallback(pagination.current_page - 1)">
          Prev
        </a>
      </li>
      <li class="col-xs-2 col-sm-2" v-if="pagination.next_page_url">
        <a class="pagination-link" aria-label="Next" @click="handleSelectPageCallback(pagination.current_page + 1)">
          Next
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
a.pagination-link {
  cursor: pointer;
}
</style>

<script>

export default {
  props: {
    pagination: {
      required: true
    }
  },
  computed: {

    pages () {
      let range = []
      let leftBound = this.pagination.current_page - 2
      let rightBound = this.pagination.current_page + 2 + 1

      for (let i = 1; i <= this.pagination.last_page; i++) {
        if (i === 1 || i === this.pagination.last_page || (i >= leftBound && i <= rightBound)) {
          range.push(i)
        }
      }

      let pages = []
      let lastAddedPage

      range.forEach((i) => {
        if (lastAddedPage) {
          if (i - lastAddedPage === 2) {
            pages.push(lastAddedPage + 1)
          } else if (i - lastAddedPage !== 1) {
            pages.push('...')
          }
        }

        pages.push(i)

        lastAddedPage = i
      })

      return pages
    }
  },

  methods: {
    /**
     * Handle selecting a page.
     *
     * Changes the page filter which triggers the search.
     *
     * @return void
     */
    handleSelectPageCallback (value) {
      if (value === '...') {
        return
      }
      this.$emit('changePage', value)
    }
  }
}
</script>
